import type { IOrthopticsV1ProcedureDiagnosticReportReadProps } from '../../OrthO/OrthOV1ProcedureDiagnosticReportRead';
import { OrthOV1ProcedureDiagnosticReportRead } from '../../OrthO/OrthOV1ProcedureDiagnosticReportRead';

export function OrthOFolV1ProcedureDiagnosticReportRead(
    props: IOrthopticsV1ProcedureDiagnosticReportReadProps
): JSX.Element {
    return (
        <OrthOV1ProcedureDiagnosticReportRead
            isOrthOFol={true}
            {...props}
        />
    );
}
